import React, { useEffect, useState } from 'react';
import { titleize } from 'underscore.string';
import { useTranslation } from 'react-i18next';
import CargomaticInput from 'components/v2/input';
import CargomaticSelect from 'components/v2/select';
import { getDeclinedAccessorialsReasonCodes } from 'utils/ReasonCodesAPI';
import USER_TYPES from 'constants/UserTypes';
const DeclineAllComponent = (props) => {
    const { t } = useTranslation();
    const { value, onNoteChange, error, declineReasonCode, onDeclineReasonCodeChange, confirmType, } = props;
    const [accessorialsDeclineReasonCodes, setAccessorialsDeclineReasonCodes] = useState([]);
    useEffect(() => {
        async function fetchReasonCodes() {
            const accessorialsReasonCodes = await getDeclinedAccessorialsReasonCodes();
            setAccessorialsDeclineReasonCodes(accessorialsReasonCodes);
        }
        if (onDeclineReasonCodeChange) {
            try {
                fetchReasonCodes();
            }
            catch (error) {
                console.log('Unable to get decline reason codes', error);
            }
        }
    }, []);
    return (React.createElement("div", { "data-testid": "div-4628a3c7" },
        React.createElement("span", { "data-testid": "span-d0cc0229" }, t('PROVIDE_DECLINE_NOTE_FOR_THIS_REQUEST')),
        React.createElement("br", { "data-testid": "br-92f7f36f" }),
        confirmType === USER_TYPES.CARRIER && (React.createElement("span", { "data-testid": "span-afaac33c", className: "text-xs text-red-700" }, t('CARRIER_RECEIVE_NOTE_VIA_EMAIL'))),
        React.createElement("div", { "data-testid": "div-43d27076", className: "py-2" },
            React.createElement(CargomaticInput, { dataTestId: "CargomaticInput-415650de", error: error, value: value, label: titleize(t('NOTE', { count: 3 })), info: t('PROVIDE_DECLINE_NOTE'), placeholder: titleize(t('NOTE', { count: 3 })), onChange: (note) => onNoteChange(note), maxLength: 100 })),
        onDeclineReasonCodeChange && (React.createElement("div", { "data-testid": "div-ca400cc4" },
            React.createElement("div", { "data-testid": "div-ef6ba087", className: "py-2" }, t('SELECT_REASON_CODE')),
            React.createElement(CargomaticSelect, { dataTestId: "CargomaticSelect-94c18db3", items: accessorialsDeclineReasonCodes, value: declineReasonCode, className: "w-auto", hideLabel: true, showCaption: true, onSelect: onDeclineReasonCodeChange })))));
};
export default DeclineAllComponent;
